// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced[data-v-1d201bdb]{-webkit-user-select:none;-moz-user-select:none;user-select:none;padding:0 5px;line-height:40px;font-size:15px;font-weight:500}.content[data-v-1d201bdb]{background:var(--nav-active);padding:10px;margin-top:6px;border-radius:4px}.locale-chooser[data-v-1d201bdb]{cursor:pointer}.locale-chooser[data-v-1d201bdb]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
